import React, { useEffect } from "react";
import { Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { getKycDetails } from "../../../redux/slices/ProfileSlice";
import Loader from "../../../components/CustomLoader/Loader";
import ProfileDetail from "../../../components/Details/ProfileDetail";
import {
  GLOBAL_CONSTANTS,
  TITLE_TXT,
  USERTYPE_ID,
} from "../../../constants/constants";

const { Title } = Typography;

const KYCDetails = () => {
  const { user } = useSelector((state) => state.auth);
  const isIndividual = user?.userTypeId === USERTYPE_ID.INDIVIDUAL;
  const isHuf = user?.userTypeId === USERTYPE_ID.HUF;
  const isCompany = user?.userTypeId === USERTYPE_ID.ENTITY;
  const isNbfc = user?.userTypeId === USERTYPE_ID.NBFC;
  const { kycDetailsData, loading } = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getKycDetails());
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="investor-details-container">
          <div className="header-container">
            <Title level={4}>{TITLE_TXT.KYC_DETS}</Title>
          </div>
          <div className="details-container">
            {(isCompany || isNbfc) && (
              <>
                <ProfileDetail
                  label={
                    isNbfc
                      ? GLOBAL_CONSTANTS.NBFC_PAN
                      : GLOBAL_CONSTANTS.COMP_PAN
                  }
                  value={kycDetailsData?.kycPanValue?.docValue || "N/A"}
                  isVerified={kycDetailsData?.kycPanValue?.isVerified}
                />

                <ProfileDetail
                  label={
                    isNbfc
                      ? GLOBAL_CONSTANTS.NBFC_GSTIN
                      : GLOBAL_CONSTANTS.COMP_GSTIN
                  }
                  value={kycDetailsData?.kycGstinValue?.docValue || "N/A"}
                  isVerified={kycDetailsData?.kycGstinValue?.isVerified}
                />

                <ProfileDetail
                  label={
                    isNbfc
                      ? GLOBAL_CONSTANTS.NBFC_BANK_ACC
                      : GLOBAL_CONSTANTS.COMP_BANK_ACC
                  }
                  value={kycDetailsData?.kycBank?.docValue || "N/A"}
                  isVerified={kycDetailsData?.kycBank?.isVerified}
                />

                <ProfileDetail
                  label={GLOBAL_CONSTANTS.DIR_PAN}
                  value={
                    kycDetailsData?.kycDirectorsPanValue?.docValue || "N/A"
                  }
                  isVerified={kycDetailsData?.kycDirectorsPanValue?.isVerified}
                />

                <ProfileDetail
                  label={GLOBAL_CONSTANTS.DIR_AADHAR}
                  value={
                    kycDetailsData?.kycDirectorsAadhaarValue?.docValue || "N/A"
                  }
                  isVerified={
                    kycDetailsData?.kycDirectorsAadhaarValue?.isVerified
                  }
                />
                {kycDetailsData?.boardResolution?.docUrl && (
                  <ProfileDetail
                    label={GLOBAL_CONSTANTS.BR}
                    value={kycDetailsData.boardResolution.docUrl}
                    isVerified={kycDetailsData.boardResolution.isVerified}
                    downloadBtn={true}
                  />
                )}
              </>
            )}
            {(isHuf || isIndividual) && (
              <>
                {isHuf && (
                  <>
                    <ProfileDetail
                      label={GLOBAL_CONSTANTS.KAR_PAN}
                      value={
                        kycDetailsData?.kycDirectorsPanValue?.docValue || "N/A"
                      }
                      isVerified={
                        kycDetailsData?.kycDirectorsPanValue?.isVerified
                      }
                    />

                    <ProfileDetail
                      label={GLOBAL_CONSTANTS.HUF_PAN}
                      value={kycDetailsData?.kycPanValue?.docValue || "N/A"}
                      isVerified={kycDetailsData?.kycPanValue?.isVerified}
                    />

                    <ProfileDetail
                      label={GLOBAL_CONSTANTS.AADHAR}
                      value={kycDetailsData?.kycDirectorsAadhaarValue?.docValue || "N/A"}
                      isVerified={kycDetailsData?.kycDirectorsAadhaarValue?.isVerified}
                    />
                  </>
                )}

                {isIndividual && (
                  <>
                    <ProfileDetail
                      label={GLOBAL_CONSTANTS.PAN}
                      value={kycDetailsData?.kycPanValue?.docValue || "N/A"}
                      isVerified={kycDetailsData?.kycPanValue?.isVerified}
                    />
                    <ProfileDetail
                      label={GLOBAL_CONSTANTS.AADHAR}
                      value={kycDetailsData?.kycAadhaar?.docValue || "N/A"}
                      isVerified={kycDetailsData?.kycAadhaar?.isVerified}
                    />
                  </>
                )}

                <ProfileDetail
                  label={GLOBAL_CONSTANTS.BANK_ACC}
                  value={kycDetailsData?.kycBank?.docValue || "N/A"}
                  isVerified={kycDetailsData?.kycBank?.isVerified}
                />
              </>
            )}

            {kycDetailsData?.platformSla?.docUrl && (
              <ProfileDetail
                label={GLOBAL_CONSTANTS.SLA}
                value={kycDetailsData.platformSla.docUrl}
                isVerified={kycDetailsData.platformSla.isVerified}
                downloadBtn={true}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default KYCDetails;
